import { atom } from 'jotai';
import { createMutationAtom } from 'atoms/create-resource-atom';
import type {
  PreDrillCreateResponse,
  PreDrillWorkspaceListResponse,
  PreDrillWorkspace,
} from 'types/api-responses';

// Self href of the workspace open in-page (local state, not a route). Set by
// Create / "open workspace"; cleared by the workspace's Back button.
export const activePreDrillWorkspaceHrefAtom = atom<string | null>(null);

// POST /wellbore_geometry_workspaces — create a workspace for a permit (returns the
// full inline workspace).
export const createPreDrillWorkspaceAtom = createMutationAtom<
  PreDrillCreateResponse,
  'createPreDrillWorkspace'
>();

// POST /queries/wellbore_geometry_workspaces — View Source's full unfiltered list for
// a UWI14. Shared with the Permits/Wellbores card's eager count fetch.
export const preDrillWorkspacesListAtom = createMutationAtom<
  PreDrillWorkspaceListResponse,
  'preDrillWorkspacesList'
>();

// POST /queries/wellbore_geometry_workspaces (promoted: true) — Edit Source's
// promoted-only list; separate atom so it never clobbers the View list.
export const preDrillEditWorkspacesListAtom = createMutationAtom<
  PreDrillWorkspaceListResponse,
  'preDrillWorkspacesList'
>();

export const selectWellboreViewWorkspacesAtom = createMutationAtom<
  PreDrillWorkspaceListResponse,
  'preDrillWorkspacesList'
>();

// POST /wellbore_geometry_workspaces/:id/default_selections — make a workspace the
// default source for its wellbore-geometry row.
export const selectDefaultPreDrillWorkspaceAtom = createMutationAtom<
  PreDrillWorkspace,
  'selectDefaultPreDrillWorkspace'
>();

// Per-wellbore selections (uwi14 → workspace id) from Edit Source Apply. Sent
// to /queries/wells so the BE drives each bore from the chosen geometry.
export const wellboreGeometryWorkspaceSelectionsAtom = atom<
  Record<string, number>
>({});
